import { Experience } from "./app/Experience";

Experience.get().init();